import React, { useState } from "react";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ChevronUp } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import config from "../../../config";
import Papa from "papaparse";
import apiHandler from "../../common/api";

function CustomerImport() {
  const route = all_routes;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);

  const [selectedFile, setSelectedFile] = useState(null);
  const [csvData, setCsvData] = useState([]);

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    if (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          console.log("Parsed JSON:", results.data);

          const custImportData = results.data?.map((item) => {
            return {
                firstName: item["First Name"],
                lastName: item["Last Name"],
                email: item["Email"],
                phoneNumber: item["Mobile Phone"],
                gender: (() => {
                const gender = item["Gender"]?.toLowerCase();
                if (
                  gender === "Male" ||
                  gender === "male" ||
                  gender === "M" ||
                  gender === "m"
                )
                  return 1;
                if (
                  gender === "Female" ||
                  gender === "female" ||
                  gender === "F" ||
                  gender === "f"
                )
                  return 2;
                if (
                  gender === "Other" ||
                  gender === "other" ||
                  gender === "O" ||
                  gender === "o"
                )
                  return 3;
                return null; // Default to null if no match
              })(),
              birthDate: item["Birthday"],
            };
          });
          setCsvData(custImportData); // store CSV data in state
        },
      });
    }
  };

  const handleSubmit = async () => {
    console.log("Submitting CSV data:", csvData);
    const formData = {
        importData: JSON.stringify(csvData),
        businessId: userData?.businessId || 0
      };

    const response = await apiHandler({
      method: "POST",
      route: `Business/customerImportUpsert`,
      payload: formData,
    });
    if (response.ResponseCode === "SUCCESS") {
      navigate(route.customerList);
    } else {
      console.log(response, "data");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h3 className="text-color-70">Customer Import</h3>
              <h6 className="text-color-40">Manage Customer Import</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <div className="text-start mb-4">
                <h5 className="fw-bold">Upload file</h5>
                <p className="text-muted">
                  Upload a CSV file with your customer data, or download and
                  fill the template below.
                </p>
              </div>

              <div
                className="border border-2 border-dashed rounded-3 p-5 text-center bg-light"
                style={{ minHeight: "250px" }}
              >
                <div className="mb-3">
                  <i className="bi bi-upload" style={{ fontSize: "2rem" }}></i>
                </div>
                <p className="mb-2 fw-semibold">Upload CSV file</p>

                <div className="d-flex justify-content-center">
                  <label className="btn btn-outline-primary">
                    Choose a CSV file
                    <input
                      type="file"
                      accept=".csv"
                      hidden
                      onChange={handleFileChange}
                    />
                  </label>
                </div>

                {selectedFile && (
                  <div className="mt-3 text-muted">
                    Selected File: <strong>{selectedFile.name}</strong>
                  </div>
                )}
              </div>

              <div className="text-muted mt-3">
                Don’t have a file? Fill our template with your customer info and
                upload.
                <br />
                <a
                  href={
                    config?.Imageurl +
                    "assets/excels/Book yarra Partners Customer Import.csv"
                  }
                  className="text-primary"
                  download
                >
                  Download template
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Add Action Buttons */}
        <div className="col-lg-12 col-md-12 col-12 mt-4">
          <div className="btn-addproduct mb-4">
            <button
              type="button"
              className="btn btn-outline-primary btn-md me-2"
              onClick={() => {
                navigate(route.customerList);
              }}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary btn-md me-2"
              onClick={(e) => handleSubmit(e)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerImport;
